import { render, staticRenderFns } from "./InputError.vue?vue&type=template&id=55708d1e&scoped=true&"
import script from "./InputError.vue?vue&type=script&lang=ts&"
export * from "./InputError.vue?vue&type=script&lang=ts&"
import style0 from "./InputError.vue?vue&type=style&index=0&id=55708d1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55708d1e",
  null
  
)

export default component.exports